<div class="minimal-modal-wrapper p-4 text-center">
    <button type="button" class="btn-close-minimal" (click)="activeModal.dismiss()">
        <span class="material-symbols-outlined">close</span>
    </button>

    <div class="icon-container mb-3">
        <div class="icon-shape primary-shape">
            <span class="material-symbols-outlined">add_link</span>
        </div>
    </div>

    <h3 class="modal-title-clean">Nuova Scansione Web</h3>
    <p class="modal-text mb-4">
        Stai per aggiungere un nuovo sito all'indice: <br>
        <strong class="text-primary">{{ indexName }}</strong>
    </p>

    <div class="input-area text-start mb-3">
        <label for="siteUrl" class="form-label fw-bold mb-2">URL del sito</label>
        <input type="url"
               id="siteUrl"
               class="form-control custom-input" 
               [(ngModel)]="urlToCrawl" 
               placeholder="https://esempio.com"
               (keyup.enter)="confirm()">
    </div>

    <div class="input-area text-start mb-3">
        <label for="maxPages" class="form-label fw-bold mb-2">Pagine massime (MAX_PAGES)</label>
        <input type="number"
               id="maxPages"
               class="form-control custom-input" 
               [(ngModel)]="maxPages" 
               min="1"
               max="1000"
               placeholder="100"
               (keyup.enter)="confirm()">
        <small class="text-muted d-block mt-1">Numero massimo di pagine da scansionare ed indicizzare ricorsivamente (default: 100).</small>
    </div>

    <div class="input-area text-start mb-4">
        <div class="form-check form-switch d-flex align-items-center gap-2 p-0">
            <input class="form-check-input ms-0 me-2" 
                   type="checkbox" 
                   role="switch" 
                   id="generatePreviewSwitch" 
                   [attr.aria-checked]="generatePreview"
                   [(ngModel)]="generatePreview">
            <label class="form-check-label fw-bold mb-0" for="generatePreviewSwitch" style="cursor: pointer;">
                Genera anteprima PDF (Gotenberg)
            </label>
        </div>
        <small class="text-muted d-block mt-1">
            Se disattivato, velocizza notevolmente la scansione evitando la conversione PDF con Gotenberg.
        </small>
    </div>

    <div class="modal-actions d-flex justify-content-center gap-3">
        <button type="button" class="btn-action btn-cancel" (click)="activeModal.dismiss()">
            Annulla
        </button>
        <button type="button" 
                class="btn-action btn-confirm" 
                [disabled]="!urlToCrawl" 
                (click)="confirm()">
            Avvia Scansione
        </button>
    </div>
</div>